import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-3xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question text-white" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "flex flex-col space-y-4" }

import { computed, ComputedRef, Ref } from "vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import ModalText from "@/components/Texts/ModalText.vue";
import { useDialogsStore } from "@/Store/useDialogsStore";
import BottomSheet from "@/components/Modals/BottomSheet.vue";
import { useGameStore } from "@/Store/useGameStore";
import { Action } from "@/Interfaces/Action";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionHelperModal',
  setup(__props) {

const gameStore = useGameStore();

const gameActions: ComputedRef<Action[]> = computed(() => {
  return gameStore.gameActions;
});

const indexAction: ComputedRef<number> = computed(() => {
  return gameStore.indexAction;
});

const dialogsStore = useDialogsStore();
const helperModal = dialogsStore.createNewDialog();

const isOpen: Ref<boolean> = computed(() => {
  return dialogsStore.dialogs[helperModal];
});

const toogleModal = () => {
  if (isOpen.value) {
    dialogsStore.closeAllModals();
  } else {
    dialogsStore.openModal(helperModal);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "fixed top-4 right-4 z-40 w-16 h-16 rounded-full flex justify-center items-center cursor-pointer transition-transform duration-1000 ease-in-out transform bg-gradient-to-b from-gray-900 to-gray-800",
      onClick: toogleModal
    }, _hoisted_2),
    _createVNode(BottomSheet, {
      "dialog-id": _unref(helperModal),
      "all-draggable": true,
      "out-side-closable": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PrimaryLabel, {
            text: "Aide",
            class: "mb-2"
          }),
          _createVNode(ModalText, { class: "text-left" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(gameActions.value[indexAction.value].help), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["dialog-id"])
  ], 64))
}
}

})